import { z } from 'zod';
import { CollectionRedirectType } from '../types';

export const translationSchema = z.object({
  languageCode: z.string().min(1, 'Código do idioma é obrigatório'),
  description: z.string().min(1, 'Descrição é obrigatória'),
});

export const itemSchema = z.object({
  itemId: z.string().uuid('ID do item inválido'),
  displayOrder: z.number().min(1, 'Ordem deve ser maior que 0'),
  image: z.string().optional(),
  name: z.string().optional(),
});

export const collectionFormSchema = z
  .object({
    name: z.string().min(1, 'Nome é obrigatório'),
    translations: z.array(translationSchema),
    items: z.array(itemSchema).optional(),
    coverImage: z.instanceof(File).optional().or(z.string().optional()),
    bannerImage: z.instanceof(File).optional().or(z.string().optional()),
    banner: z
      .object({
        redirectType: z.nativeEnum(CollectionRedirectType, {
          required_error: 'Selecione o tipo de redirecionamento',
        }),
        isActive: z.boolean(),
        startDate: z.date().optional(),
        endDate: z.date().optional(),
      })
      .optional(),
  })
  .refine(
    (data) => {
      if (data.banner) {
        return data.banner.startDate && data.banner.endDate;
      }
      return true;
    },
    {
      message: 'Data de início e fim são obrigatórias quando o banner está configurado',
      path: ['banner', 'startDate'],
    }
  );

export type CollectionFormValues = z.infer<typeof collectionFormSchema>;
export type TranslationFormValue = z.infer<typeof translationSchema>;
export type ItemFormValue = z.infer<typeof itemSchema>;
